<section class="form_section">
    <div class="dialog-header">
      <button mat-icon-button (click)="cerrarDialogo()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <h2 class="title_form">Registrar Usuario</h2>
    <form
      action=""
      class="form_register_minutes"
      [formGroup]="form"
      (ngSubmit)="submit()"
    >
      <section class="container-form-user">
        <mat-form-field class="example-form-field">
          <mat-label>Rut de Usuario</mat-label>
          <input matInput formControlName="rut" (blur)="inputRut($event)" />
        </mat-form-field>
        <div *ngIf="form.controls['rut'].errors?.['invalidRut']">
          <ng-container *ngIf="form.controls['rut'].errors?.['invalidRut']">
            Este RUT es inválido.
          </ng-container>
        </div>
        <mat-form-field class="example-form-field">
          <mat-label>Nombre</mat-label>
          <input matInput type="text" formControlName="firstName" />
        </mat-form-field>
        <mat-form-field class="example-form-field">
          <mat-label>Apellido</mat-label>
          <input matInput type="text" formControlName="lastName" />
        </mat-form-field>
        <mat-form-field class="example-form-field">
          <mat-label>email</mat-label>
          <input matInput type="text" formControlName="email" />
        </mat-form-field>
        <mat-form-field class="example-form-field">
          <mat-label>Telefono</mat-label>
          <input matInput type="text" formControlName="phone" />
        </mat-form-field>
        <mat-form-field class="example-form-field">
          <mat-label>Contraseña</mat-label>
          <input matInput type="text" formControlName="password" />
        </mat-form-field>
      </section>
      <section class="button_class">
        <button
         
          mat-stroked-button
          color="primary"
          type="submit"
          class="w-50"
        >
          Guardar
        </button>
      </section>
    </form>
  </section>
  